<template>
  <div class="template-settings-select" :class="{ [extraClass]: !!extraClass }">
    <div class="template-settings-select__header">Select Template Type</div>

    <div class="template-settings-select__select">
      <VRadioSelect
        :selected-option="builderType"
        :options="type === 'postcard' ? _optionsPostcards : _optionsLetters"
        @select="onSelect"
      ></VRadioSelect>
    </div>

    <div class="template-settings-select__builder">
      <WithLoader :isLoading="!template">
        <component
          :template="template"
          :is="chooseComponentByTemplateType.component"
          v-bind="chooseComponentByTemplateType.props"
          @upload-start="$emit('upload-start')"
          @upload-finish="
            (file, file_type) => $emit('upload-finish', file, file_type)
          "
          @savePdfUrl="val => $emit('savePdfUrl', val)"
          @saveHtml="$emit('saveHtml')"
        />
      </WithLoader>
    </div>
    <VConfirmModal
      :isOpened="isConfirmModalOpened"
      text="This will change the template, proceed?"
      :titles="{ primary: 'Yes', secondary: 'No' }"
      @approve="confirmModalHandler('approve')"
      @cancel="confirmModalHandler()"
    ></VConfirmModal>
  </div>
</template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";

// components
import TemplateHtmlBuilder from "@/components/TemplateHtmlBuilder";
import VUploaderDropZone from "@/components/VUploaderDropZone";
import LettersUploaderUrl from "@/components/LettersUploaderUrl";
import WithLoader from "@/components/WithLoader";
import VRadioSelect from "@/components/VRadioSelect";
import VConfirmModal from "@/components/VConfirmModal";

//icons
import pdfIcon from "@/assets/images/pdf-icon.svg";
import htmlIcon from "@/assets/images/html-icon.svg";
import folderIcon from "@/assets/images/folder-icon.svg";
import settingsIcon from "@/assets/images/settings-icon.svg";

export default Vue.component("TemplateSettingsSelect", {
  props: {
    uploaderType: VueTypes.string,
    template: VueTypes.object,
    type: VueTypes.oneOf(["letter", "postcard"]),
    extraClass: VueTypes.string
  },

  data() {
    return {
      builderType: this.uploaderType,
      preConfirmBuilderType: "",
      isConfirmModalOpened: false,
      /*
        If component needs to be in the same div with selector - maps below should be used
        Otherwise you can catch {eventName} event and use your component everywhere in the DOM tree
      */
      letterComponentsMap: {
        html: {
          component: TemplateHtmlBuilder,
          props: { type: "letter" }
        },
        // pdf: {
        //   component: VUploaderDropZone,
        //   props: {
        //     label: "Drag and Drop HTML/PDF Here",
        //     maxFiles: 1,
        //     fileTypes: "application/pdf, text/html"
        //   }
        // },
        pdf: {
          component: LettersUploaderUrl,
          props: {
            label: "Drag and Drop HTML/PDF Here",
            maxFiles: 1,
            fileTypes: "application/pdf"
          }
        }
      },

      /*This map state should be defined but is empty
      cause components import to parent component due to css issue*/
      postcardComponentsMap: {
        html: { component: {} },
        template_object: { component: {} }
      }
    };
  },

  components: {
    TemplateHtmlBuilder,
    VUploaderDropZone,
    LettersUploaderUrl,
    WithLoader,
    VRadioSelect,
    VConfirmModal
  },

  computed: {
    _optionsLetters() {
      return [
        {
          key: "html",
          value: "html",
          title: "HTML",
          iconSrc: htmlIcon
        },
        // {
        //   key: "url",
        //   value: "url",
        //   title: "Insert URL",
        //   iconSrc: pdfIcon
        // },
        {
          key: "pdf",
          value: "pdf",
          title: "PDF",
          iconSrc: folderIcon
        }
      ];
    },

    _optionsPostcards() {
      return [
        {
          key: "html",
          value: "html",
          title: "HTML",
          iconSrc: htmlIcon
        },

        {
          key: "template_object",
          value: "template_object",
          title: "Builder",
          iconSrc: settingsIcon
        }
      ];
    },

    chooseComponentByTemplateType() {
      return this.type === "letter"
        ? this.letterComponentsMap[this.uploaderType]
        : this.postcardComponentsMap[this.uploaderType];
    }
  },

  methods: {
    onSelect(selected) {
      this.preConfirmBuilderType = selected;
      this.isConfirmModalOpened = true;
    },

    confirmModalHandler(approve) {
      if (approve) {
        this.builderType = this.preConfirmBuilderType;
        this.$emit("changeType", this.builderType);
      }
      this.preConfirmBuilderType = "";
      this.isConfirmModalOpened = false;
    }
  },

  watch: {
    uploaderType() {
      this.builderType = this.uploaderType;
    }
  }
});
</script>

<style lang="scss" scoped>
$ns: "template-settings-select";

.template-settings-select {
  width: 100%;

  // &__builder {
  //   margin-top: 53px;
  // }
}

.#{$ns} {
  &__header {
    font-family: Lato-Regular, Arial, sans-serif;
    font-size: 22px;
    line-height: 1.2;
    margin-bottom: 30px;
  }
}

/*for select template*/
/deep/ .v-billing-select__wrapper {
  .current-item:hover {
    box-shadow: 0px 0px 25px rgba(0, 0, 0, 0.08);
  }
}
</style>
